import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import RecoverPasswordContent from "./RecoverPasswordContent";
import RecoverPasswordButtons from "./widget/RecoverPasswordButtons";
import { RecoverPasswordContextProvider } from "../../../../provider/onboarding/forgot_password/recover_password/RecoverPasswordContextProvider";
import AppConfigService from "../../../../service/app_config/AppConfigService";

const RecoverPasswordScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <RecoverPasswordContextProvider>
      <Scaffold
        appBarTitle={
          type === 3 ? undefined : AppConfigService.get("company_name")
        }
        bottomNavigationButton={<RecoverPasswordButtons />}
      >
        <MainBodyContainer className={type !== 3 ? "pt-5" : ""}>
          <RecoverPasswordContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </RecoverPasswordContextProvider>
  );
};

export default RecoverPasswordScreen;
export const routeName: string = "/recover-password";
